import { ISubsectionProps } from "~/lib/types/article.type";
import { getTranslationVariable } from "~/lib/utils/helper/getVariableTranslation";
import { SearchForm } from "../../search-bar/help-centre-search-bar";
import { useLocale } from "~/i18n/i18n.client";

export const ArticleLabel = ({
  selectedSubsection,
}: {
  selectedSubsection?: ISubsectionProps;
}) => {
  const locale = useLocale();
  return (
    <div className="flex flex-col gap-6 p-5 md:p-10 bg-carbon-700 md:rounded-xl">
      <div className="flex flex-row gap-5 items-center">
        {selectedSubsection?.imageUrl && (
          <img
            src={selectedSubsection?.imageUrl}
            width={56}
            height={56}
            alt={`${getTranslationVariable(
              selectedSubsection.label,
              locale
            )} icon`}
          />
        )}
        <span className="font-title font-semibold text-xl md:text-[40px] leading-7 md:leading-[58px] text-white">
          {getTranslationVariable(selectedSubsection?.label, locale)}
        </span>
      </div>
      <div className="hidden md:block">
        <SearchForm />
      </div>
    </div>
  );
};
